module.exports = __webpack_public_path__ + "static/img/102410.de1c060f.png";